import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import axiosHttp from "services/axiosHttp";

//create action
export const createDesignation = createAsyncThunk(
  "createDesignation",
  async ({ data, form, history }) => {
    const token = localStorage.getItem("auth_token");
        const config = {
            headers: {
                "Authorization": `Bearer ${token}`,
                "Access-Control-Allow-Origin": '*',
                "Content-Type": "application/json",
                "Accept": "application/json",
            }
        };
    const response = await axiosHttp.post(
      `designation/create`,
      data,
      config
    );

    form.resetFields();
    message.success("Designation successfully created!");
    history("/app/employee/designation");
    return response.data;
  }
);

const designationCreateSlice = createSlice({
  name: "designationCreate",
  initialState: {
    isLoading: false,
    error: null,
  },

  extraReducers: (builder) => {
    builder.addCase(createDesignation.pending, (state, action) => {
      state.isLoading = true;
    });

    builder.addCase(createDesignation.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(createDesignation.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

export default designationCreateSlice.reducer;